import { render, staticRenderFns } from "./item-radio.vue?vue&type=template&id=4ee2a970&scoped=true"
import script from "./item-radio.vue?vue&type=script&setup=true&lang=js"
export * from "./item-radio.vue?vue&type=script&setup=true&lang=js"
import style0 from "./item-radio.vue?vue&type=style&index=0&id=4ee2a970&prod&lang=less&scoped=true"
import style1 from "./item-radio.vue?vue&type=style&index=1&id=4ee2a970&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ee2a970",
  null
  
)

export default component.exports